import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const ModalWrapper = styled.div(
  (props: { collapsed: boolean }) => css`
    display: ${props.collapsed ? 'none' : 'initial'};
  `
)

export const Column = styled.div(
  ({ gap = '0.5em' }: { gap?: string }) => css`
    display: grid;
    grid-row-gap: ${gap};

    max-width: 100%;

    & > button,
    & > a {
      width: fit-content;
    }
  `
)

export const Row = styled.div(
  ({ gap = '0.5em', justify }: { gap?: string; justify?: string }) => css`
    display: flex;
    gap: ${gap};

    ${justify &&
    css`
      justify-content: ${justify};
    `}
  `
)

export const CloseButtonWrapper = styled.div`
  display: flex;
  justify-self: flex-end;
`

export const HeaderWrapper = styled.div`
  display: flex;
  gap: 5px;

  & > div {
    align-self: flex-end;
    margin-bottom: 5px;
  }
`

export const Ellipsis = styled.span`
  max-width: 100%;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
`

export const SuggestedContactRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px;
  max-width: 100%;
  gap: 0.5em;

  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
